module.exports = __webpack_public_path__ + "img/satelliteFlash.23acd8d4.png";